module.exports = __webpack_public_path__ + "img/damage-purple.dc6c9ed8.svg";